import * as React from 'react';

import { Button } from '@lightspeed/flame/Button';
import { Flex } from '@lightspeed/flame/Core';
import { Text } from '@lightspeed/flame/Text';
import { getStore } from 'pages/store/selectors/employeeShops';
import { theme } from '@lightspeed/flame/Core/themes/flame';
import { useSelector } from 'react-redux';

interface Props {
  disabled: boolean;
  onClick: () => void;
}

const EditShopsButton: React.FC<Props> = ({ disabled, onClick }) => {
  const { isPrimaryUser, shops } = useSelector(getStore);
  const employeeShops = shops.filter(shop => shop.hasAccess);

  return (
    <Flex justifyContent="space-between" alignItems="center" p={1}>
      {isPrimaryUser ? (
        <Text fontWeight="bold" textAlign="left" py={1}>
          You do not have permission to edit location access.
        </Text>
      ) : (
        <>
          <Text
            color={disabled ? theme.colors['gray-600'] : theme.colors.black}
            data-testid="shop-counter"
          >
            <var>{employeeShops.length}</var> of <var>{shops.length}</var> locations
          </Text>
          <Button
            css={{ minWidth: '48px' }}
            data-testid="edit-shops-btn"
            disabled={disabled}
            fill
            onClick={onClick}
            p={1}
          >
            Edit
          </Button>
        </>
      )}
    </Flex>
  );
};

export default EditShopsButton;
